// Reducer for the Communication / Notification settings feature

import {
  GET_COMMUNICATION_LIST,
  GET_COMMUNICATION_LIST_SUCCESS,
  GET_COMMUNICATION_LIST_FAIL,
  GET_COMMUNICATION_CHANNEL_LIST,
  GET_COMMUNICATION_CHANNEL_LIST_SUCCESS,
  GET_COMMUNICATION_CHANNEL_LIST_FAIL,
  CREATE_COMMUNICATION_CHANNEL,
  CREATE_COMMUNICATION_CHANNEL_SUCCESS,
  CREATE_COMMUNICATION_CHANNEL_FAIL,
  UPDATE_COMMUNICATION_CHANNEL,
  UPDATE_COMMUNICATION_CHANNEL_SUCCESS,
  UPDATE_COMMUNICATION_CHANNEL_FAIL,
  GET_COMMUNICATION_PLACEHOLDER_LIST,
  GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS,
  GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL,
  GET_NOTIFICATION_TEMPLATE_LIST,
  GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS,
  GET_NOTIFICATION_TEMPLATE_LIST_FAIL,
} from "./actionType";

const initialState = {
  communicationList: {},
  communicationListLoading: false,

  communicationChannelList: {},
  communicationChannelListLoading: false,

  createCommunicationChannel: {},
  createCommunicationChannelLoading: false,

  updateCommunicationChannel: {},
  updateCommunicationChannelLoading: false,

  communicationPlaceholderList: {},
  communicationPlaceholderListLoading: false,

  notificationTemplateList: {},
  notificationTemplateListLoading: false,

  error: {},
};

const CommunicationReducer = (state = initialState, action) => {
  switch (action.type) {
    // Communication list
    case GET_COMMUNICATION_LIST:
      return { ...state, communicationListLoading: true };
    case GET_COMMUNICATION_LIST_SUCCESS:
      return {
        ...state,
        communicationList: action.payload,
        communicationListLoading: false,
      };
    case GET_COMMUNICATION_LIST_FAIL:
      return {
        ...state,
        communicationListLoading: false,
        error: action.payload,
      };

    // Communication channel list
    case GET_COMMUNICATION_CHANNEL_LIST:
      return { ...state, communicationChannelListLoading: true };
    case GET_COMMUNICATION_CHANNEL_LIST_SUCCESS:
      return {
        ...state,
        communicationChannelList: action.payload,
        communicationChannelListLoading: false,
      };
    case GET_COMMUNICATION_CHANNEL_LIST_FAIL:
      return {
        ...state,
        communicationChannelListLoading: false,
        error: action.payload,
      };

    // Create communication channel
    case CREATE_COMMUNICATION_CHANNEL:
      return {
        ...state,
        createCommunicationChannel: {},
        createCommunicationChannelLoading: true,
      };
    case CREATE_COMMUNICATION_CHANNEL_SUCCESS:
      return {
        ...state,
        createCommunicationChannel: action.payload,
        createCommunicationChannelLoading: false,
      };
    case CREATE_COMMUNICATION_CHANNEL_FAIL:
      return {
        ...state,
        createCommunicationChannelLoading: false,
        error: action.payload,
      };

    // Update communication channel
    case UPDATE_COMMUNICATION_CHANNEL:
      return {
        ...state,
        updateCommunicationChannel: {},
        updateCommunicationChannelLoading: true,
      };
    case UPDATE_COMMUNICATION_CHANNEL_SUCCESS:
      return {
        ...state,
        updateCommunicationChannel: action.payload,
        updateCommunicationChannelLoading: false,
      };
    case UPDATE_COMMUNICATION_CHANNEL_FAIL:
      return {
        ...state,
        updateCommunicationChannelLoading: false,
        error: action.payload,
      };

    // Communication placeholder list
    case GET_COMMUNICATION_PLACEHOLDER_LIST:
      return { ...state, communicationPlaceholderListLoading: true };
    case GET_COMMUNICATION_PLACEHOLDER_LIST_SUCCESS:
      return {
        ...state,
        communicationPlaceholderList: action.payload,
        communicationPlaceholderListLoading: false,
      };
    case GET_COMMUNICATION_PLACEHOLDER_LIST_FAIL:
      return {
        ...state,
        communicationPlaceholderListLoading: false,
        error: action.payload,
      };

    // Notification template list
    case GET_NOTIFICATION_TEMPLATE_LIST:
      return { ...state, notificationTemplateListLoading: true };
    case GET_NOTIFICATION_TEMPLATE_LIST_SUCCESS:
      return {
        ...state,
        notificationTemplateList: action.payload,
        notificationTemplateListLoading: false,
      };
    case GET_NOTIFICATION_TEMPLATE_LIST_FAIL:
      return {
        ...state,
        notificationTemplateListLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default CommunicationReducer;
